import { memo, ReactNode } from 'react'

import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import {
  ContactDuplicate,
  ContactGeneralInfo,
  ContactStatus,
  IContact,
  TContactFormKeys,
} from 'clickNgo/entities/contact'
import { TSearchPortalContact } from 'clickNgo/entities/contact/api'
import { IPartner } from 'clickNgo/entities/partner/models'
import { ContactDuplicateReactivation } from 'clickNgo/features/contact/contactReactivation'
import { IAccessibility } from 'clickNgo/models/widget'
import { InfoBlock, InfoBlockType } from 'cng-common/components/infoBlock'
import { RenderWhen } from 'cng-common/components/renderWhen'
import { Nullable } from 'cng-common/models/utils'
import { FieldGroupColor } from 'shared/components/fieldGroup'

import { contactCreatorTranslation } from '../../../translation'

import styles from './GeneralStep.module.scss'

interface IProps extends IAccessibility {
  contact: IContact
  partner: IPartner
  formKeys: TContactFormKeys
  duplicate: Nullable<TSearchPortalContact>
  errorMessages?: ReactNode[]
  onReactivationComplete: (contact: IContact) => void
  isDuplicateReactivated: boolean
}

export const GeneralStep = memo<IProps>(
  (props) => {
    return (
      <>
        <InfoBlock
          text={contactCreatorTranslation.steps.general.messages.info}
          type={InfoBlockType.Help}
          hasCloseButton={true}
        />
        <div className={styles.container}>
          <ContactGeneralInfo {...props} isCollapsible hasOwnWarning />
          <RenderWhen condition={Boolean(props.duplicate)}>
            <ContactDuplicate duplicate={props.duplicate} color={FieldGroupColor.Danger}>
              <RenderWhen condition={props.duplicate?.status === ContactStatus.Inactive}>
                <ContactDuplicateReactivation
                  partner={props.partner}
                  duplicate={props.duplicate!}
                  onReactivationComplete={props.onReactivationComplete}
                  source={ProfilingRequestSource.ClickAndGoPortal}
                />
              </RenderWhen>
            </ContactDuplicate>
          </RenderWhen>
        </div>
      </>
    )
  },
  (prev, next) => prev.contact.contactId === next.contact.contactId
)

GeneralStep.displayName = 'GeneralStep'
